import React, { useState, useCallback, useEffect } from "react";
import { Container, Content, Title, Field, Input, Label } from "./styles";

import {
  Modal,
  Button,
  Checkbox,
  Icon,
  Dropdown,
  Form,
  TextArea,
  Tab,
} from "semantic-ui-react";

import { producaov2 as api } from "../../../services/apis";

import swal from "sweetalert";

const CursosSelector = props => {
  const [curso, setCurso] = useState(props.is_multiple ? [] : "");
  const [cursosOptions, setCursosOptions] = useState([]);
  const [cursoSearch, setCursoSearch] = useState("");

  const handleCursoChange = useCallback((e, { options, value }) => {
    if (props.is_multiple) {
      setCurso(value);
      
      if (props.handleChange) {
        props.handleChange(value);
      }
    } else {
      const text = options?.find(option => option.value === value)?.text || "";
      setCurso(value);
      setCursoSearch(text);

      if (props.handleChange) {
        if(props?.fullInfo) {
          const course = options?.find(option => option.value === value);
          return props.handleChange(course)
        }

        props.handleChange(value);
      }
    }
  }, [props]);

  const handleCursoSearchChange = useCallback((e, { searchQuery }) => {
    try {
      setCursoSearch(searchQuery);

      api.get(`cursos-simplelist?search=${searchQuery}&limit=15`, {
        params: {
          excludeIDs: props?.excludeCourseIDs
        }
      }).then(res => {
        const searchResults = res.data.length > 0
          ? res.data.map((course, index) => ({
              key: index,
              text: `[${course.id}] ${course.curso}`,
              value: course.id,
              type: course?.type,
              id: course?.id
            }))
          : [];

        // Se for múltiplo, mantém os cursos já selecionados nas opções
        if (props.is_multiple && Array.isArray(curso) && curso.length > 0) {
          const selectedOptions = cursosOptions.filter(option => 
            curso.includes(option.value)
          );
          
          // Une os cursos selecionados com os novos resultados, removendo duplicatas
          const combinedOptions = [
            ...selectedOptions,
            ...searchResults.filter(
              result => !curso.includes(result.value)
            )
          ];
          
          setCursosOptions(combinedOptions);
        } else {
          setCursosOptions(searchResults);
        }
      });
    } catch (err) {
      console.error(err);
      setCursosOptions([]);
    }
  }, [props, curso, cursosOptions]);

  return (
    <Container>
      <div>
        {!props?.noLabel && <Label>Selecione o curso</Label>}
        <Dropdown
          placeholder="Busque pelo ID ou pelo nome do curso"
          fluid
          search
          selection
          options={cursosOptions}
          onChange={handleCursoChange}
          searchQuery={cursoSearch}
          onSearchChange={handleCursoSearchChange}
          value={curso}
          clearable
          {...(props.is_multiple && { multiple: true })}
        />
      </div>
    </Container>
  );
};

export default CursosSelector;